import { render, staticRenderFns } from "./darksidead-add-or-update.vue?vue&type=template&id=2dcd4c8a"
import script from "./darksidead-add-or-update.vue?vue&type=script&lang=js"
export * from "./darksidead-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./darksidead-add-or-update.vue?vue&type=style&index=0&id=2dcd4c8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports